import React, { FunctionComponent } from "react";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import Styles from "./Dropdown.module.css";
type props = {
  title?: string;
  option?: any[];
  setDetails?: () => void;
  setSelectedValue: (val: any) => any;
  selectedValue?: any;
  disable?: boolean;
  choices?: any[];
  isMulti?: boolean;
  style?: any;
  placeholder?: string;
  classNameModifier?: any;
  isAutoSuggestionDropdown?: any;
  searchString?: (val: any) => any;
  setApiLocationData?: () => void;
  // values?:any;
};
const animatedComponents = makeAnimated();
const DropDownWithDisplayName: FunctionComponent<props> = ({
  title,
  option,
  setDetails,
  selectedValue,
  setSelectedValue,
  disable,
  choices,
  isMulti,
  style,
  placeholder,
  classNameModifier,
  isAutoSuggestionDropdown,
  searchString,
  setApiLocationData,
  // values
}) => {
  const choice = () => {
    if (option) {
      const data = option.map((item: any, index: number) => {
        console.log("tbgrvfedcs",item)
        return item === "Team Lead"
          ? {
              value: item,
              label: "Team Lead",
            }
          : { value: item.value, label: item.displayName };
      });

      if (title) {
        data.push({ label: title, value: title });

        return data;
      } else {
        return data;
      }
    } else {
      return choices ? choices : [];
    }
  };
  return (
    <>
      {isAutoSuggestionDropdown === true ? (
        <Select
          className={`${Styles.select} ${classNameModifier}`}
          menuPlacement="auto"
          maxMenuHeight={150}
          options={choice()}
          value={selectedValue.label === "Select"?placeholder:selectedValue}
          components={animatedComponents}
          onChange={(data) => {
            if (data?.label === title) {
              if (setDetails) setDetails();
            }
            setSelectedValue(data);
          }}
          showCheckbox={true}
          isSearchable={true}
          isDisabled={disable}
          isMulti={isMulti}
          style={style}
          placeholder={placeholder}
          onInputChange={(inputValue, { action }) => {
            if (action === "input-change") {
              if (searchString) {
                searchString(inputValue);
              }
            }
          }}
          onMenuOpen={() => {
            if (setApiLocationData) {
              setApiLocationData();
            }
          }}
        />
      ) : (
        <Select
          className={`${Styles.select} ${classNameModifier}`}
          menuPlacement="auto"
          maxMenuHeight={150}
          options={choice()}
          value={selectedValue}
          components={animatedComponents}
          onChange={(data) => {
            if (data?.label === title) {
              if (setDetails) setDetails();
            }
            setSelectedValue(data);
          }}
          showCheckbox={true}
          isSearchable={true}
          isDisabled={disable ? true : choice().length === 0 ? true : false}
          isMulti={isMulti}
          style={style}
          placeholder={placeholder}
        />
      )}
    </>
  );
};

export default DropDownWithDisplayName;
